export default class LoginOtpRequest {
    email: string = "";
    otp: string = "";
    loginId: string = "";
    institutionId: string = "";
}